import ErrorComponent from "components/shared/ErrorComponent";
import Loader from "components/shared/Loader";
import { isError } from "lodash";
import React, { useState, useEffect, useMemo } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import {
  useFetchTimezoneListQuery,
  useFetchUserTimezoneListQuery,
  useSaveTimezoneMutation,
} from "store/services/user.service";

const Timezone = () => {
  const { data: timezones, isLoading, isError } = useFetchTimezoneListQuery();
  const { data: userTimezone } = useFetchUserTimezoneListQuery();
  const [selectedTimezone, setSelectedTimezone] = useState(null);
  const [saveTimezone, { isLoading: isSaving }] =
    useSaveTimezoneMutation();

  const timezoneOptions = useMemo(() => {
    if(!timezones?.length) {
      return [];
    }
    return timezones.map((timezone) => ({
      value: timezone?._id,
      label: timezone?.name,
    }));
  }, [timezones]);

  useEffect(() => {
    if(!userTimezone || !timezones?.length) {
      return;
    }
    const timezone = timezones.find(
      (tz) => tz?._id === userTimezone?.timezoneId
    );
    setSelectedTimezone(
      timezone ? { value: timezone._id, label: timezone.name } : null
    );
  }, [userTimezone, timezones]);

  const handleTimezoneChange = (timezone) => {
    const timezoneId = timezone.value;
    setSelectedTimezone(timezone);

    saveTimezone({ timezoneId })
      .unwrap()
      .then((response) => {
        toast.success("Timezone saved successfully");
      })
      .catch((error) => {
        console.error("Failed to save timezone:", error);
        toast.error("Failed to save timezone");
      });
  };

  if (isSaving) {
    toast.success("Saving timezone");
  }

  return (
    <div className="inner timezoneTab">
      <Row>
        <Col lg="12" className="my-2">
          {isLoading ? (
            <Loader />
          ): isError ? (
            <ErrorComponent />
          ):(
            <>
              <h1>Select Timezone</h1>
              <Select
                id="timezone"
                name="timezone"
                value={selectedTimezone}
                options={timezoneOptions}
                onChange={handleTimezoneChange}
                placeholder="Select a timezone"
                className="react-select-container"
                classNamePrefix="react-select"
              />
          </>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Timezone;
